import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faRefresh, faArrowUp, faLightbulb, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const AIInsights: React.FC = () => {
  return (
    <section id="ai-insights" className="mb-8">
      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-xl flex items-center justify-center">
              <FontAwesomeIcon icon={faBrain} className="text-white" />
            </div>
            <h2 className="text-xl font-semibold text-white">AI Destekli Öngörüler</h2>
          </div>
          <button className="text-purple-400 hover:text-purple-300 transition-colors">
            <FontAwesomeIcon icon={faRefresh} className="mr-2" />
            Yenile
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="space-y-4">
              <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl border border-green-400/20">
                <div className="w-8 h-8 bg-green-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faArrowUp} className="text-black text-sm" />
                </div>
                <div>
                  <h4 className="text-green-400 font-medium mb-1">Fırsat Tespit Edildi</h4>
                  <p className="text-white/80 text-sm mb-2">
                    Instagram etkileşiminiz Salı akşamları zirve yapıyor. Bu zaman diliminde premium içerik paylaşmayı düşünün.
                  </p>
                  <button className="text-green-400 text-sm hover:text-green-300 transition-colors">
                    Daha fazla bilgi →
                  </button>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl border border-blue-400/20">
                <div className="w-8 h-8 bg-blue-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faLightbulb} className="text-black text-sm" />
                </div>
                <div>
                  <h4 className="text-blue-400 font-medium mb-1">İçerik Önerisi</h4>
                  <p className="text-white/80 text-sm mb-2">
                    Video içerikler kitleniz için görsellerden 3 kat daha iyi performans gösteriyor. Daha fazla kısa video içerik eklemeyi deneyin.
                  </p>
                  <button className="text-blue-400 text-sm hover:text-blue-300 transition-colors">
                    Önerileri gör →
                  </button>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl border border-yellow-400/20">
                <div className="w-8 h-8 bg-yellow-400 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FontAwesomeIcon icon={faExclamationTriangle} className="text-black text-sm" />
                </div>
                <div>
                  <h4 className="text-yellow-400 font-medium mb-1">Dikkat Gerekli</h4>
                  <p className="text-white/80 text-sm mb-2">
                    Yorumlara yanıt süreniz %40 arttı. Hızlı yanıtlar etkileşimi önemli ölçüde artırır.
                  </p>
                  <button className="text-yellow-400 text-sm hover:text-yellow-300 transition-colors">
                    Otomasyon kur →
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="backdrop-blur-xl bg-white/5 p-4 rounded-xl border border-white/10">
              <h4 className="text-white font-medium mb-3">AI Güven Skoru</h4>
              <div className="relative">
                <div className="w-20 h-20 mx-auto mb-3">
                  <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
                    <path 
                      className="text-white/20" 
                      stroke="currentColor" 
                      strokeWidth="3" 
                      fill="none" 
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    ></path>
                    <path 
                      className="text-purple-400" 
                      stroke="currentColor" 
                      strokeWidth="3" 
                      fill="none" 
                      strokeDasharray="85, 100" 
                      d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    ></path>
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-lg font-bold text-white">85%</span>
                  </div>
                </div>
              </div>
              <p className="text-white/50 text-xs text-center">30 günlük veri analizine dayalı</p>
            </div>

            <div className="backdrop-blur-xl bg-white/5 p-4 rounded-xl border border-white/10">
              <h4 className="text-white font-medium mb-3">Trend Hashtag'ler</h4>
              <div className="flex flex-wrap gap-2">
                <span className="px-2 py-1 bg-purple-600/20 text-purple-400 text-xs rounded-lg">#socialmedia</span>
                <span className="px-2 py-1 bg-blue-600/20 text-blue-400 text-xs rounded-lg">#marketing</span>
                <span className="px-2 py-1 bg-green-600/20 text-green-400 text-xs rounded-lg">#ai</span>
                <span className="px-2 py-1 bg-pink-600/20 text-pink-400 text-xs rounded-lg">#analytics</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIInsights;
